import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PoUploadComponent } from './components/po-upload/po-upload.component'
import { ConfigModule, PageMetaResolver, provideConfig, provideDefaultConfig } from '@spartacus/core'
import { MbI18nModule } from '../translations/mb-i18n.module'
import { SafeHtmlModule } from '../cms/pipes/sanitize-html/safe-html.module'
import { MbFormErrorsModule } from '../shared/components/mb-form-errors/mb-form-errors.module'
import { ReactiveFormsModule } from '@angular/forms'
import { DirectiveModule } from '../shared/directive.module'
import { RouterModule } from '@angular/router'
import { poUploadRoutes, poUploadRoutingConfig } from './config/po-upload-routing-config'
import { PoUploadConfirmationComponent } from './components/po-upload-confirmation/po-upload-confirmation.component'
import { PoUploadAdapter } from './connectors/po-upload/po-upload.adapter'
import { OccPoUploadAdapter } from './adapters/occ-po-upload.adapter'
import { PoUploadStoreModule } from './store/po-upload-store.module'
import { MiltenyiPoUploadPageMetaResolver } from './services/miltenyi-po-upload-page-meta.resolver'
import { MiltenyiPoUploadConfirmationPageMetaResolver } from './services/miltenyi-po-upload-confirmation-page-meta.resolver'

@NgModule({
  declarations: [
    PoUploadComponent,
    PoUploadConfirmationComponent
  ],
  imports: [
    CommonModule,
    MbI18nModule,
    SafeHtmlModule,
    MbFormErrorsModule,
    ReactiveFormsModule,
    DirectiveModule,
    PoUploadStoreModule,
    RouterModule.forChild(poUploadRoutes),
    ConfigModule.withConfig({
      cmsComponents: {
        po_upload: { component: () => import('./components/po-upload/po-upload.component').then(m => m.PoUploadComponent) },
      }
    })
  ],
  providers: [
    provideDefaultConfig(poUploadRoutingConfig),
    provideConfig({
      cmsComponents: {
        MiltenyiPurchaseOrderUploadComponent: {
          component: PoUploadComponent
        },
        MiltenyiPurchaseOrderUploadConfirmationComponent: {
          component: PoUploadConfirmationComponent
        }
      }
    }),
    {
      provide: PoUploadAdapter,
      useExisting: OccPoUploadAdapter
    },
    {
      provide: PageMetaResolver,
      useExisting: MiltenyiPoUploadPageMetaResolver,
      multi: true,
    },
    {
      provide: PageMetaResolver,
      useExisting: MiltenyiPoUploadConfirmationPageMetaResolver,
      multi: true,
    },
  ]
})
export class PoUploadModule { }
